import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useManagerAuth } from './useManagerAuth';

export const useCurrentUserRole = () => {
  const { member } = useManagerAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (member) {
      setIsAdmin(member.role === 'ADMIN');
      setLoading(false);
    } else {
      setIsAdmin(false);
      setLoading(false);
    }
  }, [member]);

  return { isAdmin, loading };
};